import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AccPatientFormType } from '@principle-theorem/principle-core/interfaces';
import { AccEmploymentFormGroup } from '../form-groups/acc-employment.formgroup';
import { AccInjuryFormGroup } from '../form-groups/acc-injury.formgroup';
import { AccPatientFormGroup } from '../form-groups/acc-patient.formgroup';
import { AccEmploymentFormComponent } from '../form-components/acc-employment-form/acc-employment-form.component';
import { AccInjuryFormComponent } from '../form-components/acc-injury-form/acc-injury-form.component';
import { AccPatientFormComponent } from '../form-components/acc-patient-form/acc-patient-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'pr-acc-patient-forms',
  imports: [
    AccEmploymentFormComponent,
    AccInjuryFormComponent,
    AccPatientFormComponent,
  ],
  templateUrl: './acc-patient-forms.component.html',
  styleUrl: './acc-patient-forms.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccPatientFormsComponent {
  formType = input.required<AccPatientFormType>();
  accDetailsChange = output<object>();
  isValid = output<boolean>();

  patientForm = new AccPatientFormGroup();
  injuryForm = new AccInjuryFormGroup();
  employmentForm = new AccEmploymentFormGroup();

  readonly accPatientFormType = AccPatientFormType;

  constructor() {
    this.patientForm.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this.accDetailsChange.emit(value));

    this.patientForm.statusChanges
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.isValid.emit(this.patientForm.valid));

    this.injuryForm.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this.accDetailsChange.emit(value));

    this.injuryForm.statusChanges
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.isValid.emit(this.injuryForm.valid));

    this.employmentForm.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this.accDetailsChange.emit(value));

    this.employmentForm.statusChanges
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.isValid.emit(this.employmentForm.valid));
  }
}
